<template>
	<div class="user-profile">
		<!-- BIG SLOGAN -->
		<div class="container">
      <p class="crowd-or-rais">
        <router-link to="/crowdfunding" class="crowd-or uppercase">{{ $t("project.crowdfunding") }}</router-link>
        <span class="or">/</span>
        <router-link to="/fundraising" class="rais-or uppercase">{{ $t("project.fundraising") }}</router-link>
      </p>
			<h1 class="big-slogan-blue mb-30">{{ user.full_name }}</h1>
		</div><!-- .container -->

		<!-- PROFILE -->
		<div class="container mb-30 profile">
			<div class="row">
				<div class="col-md-4">
					<div class="profile-text">
						<p><i class="fa fa-map-marker" aria-hidden="true"></i> {{ user.city }}, {{ user.country_id }}</p>
						<p class="short-desc"><strong>{{ $t("profile.show.user") }}</strong>{{ user.short_description }}</p>
						<p class="short-desc"><strong>{{ $t("profile.show.specialist") }}</strong></p>
						<p>
							<router-link v-if="user.profession" :to="{ name: 'profiles', query: { profession_id: user.profession.id, profession: user.profession.name }}">{{ user.profession.name }}</router-link></br>
						</p>
					</div><!-- .profile-text -->
				</div><!-- .col-md-4 -->
				<div class="col-md-4">
					<div class="profile-photo">
						<img v-if="user.photo.url" :src="$server_url + user.photo.url">
					</div><!-- .profile-photo -->
				</div><!-- .col-md-4 -->
				<div class="col-md-4">
					<div class="profile-right">
						<p>
							<strong>{{ projects.length }}</strong> {{ $t("profile.show.campaigns") }}</br>
							<strong>{{ contributions.length }}</strong> {{ $t("profile.show.contributions") }}</br>
							<strong>{{ comments.length }}</strong> {{ $t("profile.show.comments") }}</br>
						</p>
						<p><strong>{{ $t("profile.show.findMe") }}</strong></p>
						<p>
							<a v-if='user.facebook' :href="'https://' + user.facebook.replace(/(^\w+:|^)\/\//, '')" title="Facebook"><i class="fa fa-facebook-square fa-2x"></i></a>
							<a v-if='user.twitter' :href="'https://' + user.twitter.replace(/(^\w+:|^)\/\//, '')" title="Twitter"><i class="fa fa-twitter-square fa-2x"></i></a>
							<a v-if='user.google' :href="'https://' + user.google.replace(/(^\w+:|^)\/\//, '')" title="Google +"><i class="fa fa-google-plus-square fa-2x"></i></a>
              <a v-if='user.youtube' :href="'https://' + user.youtube.replace(/(^\w+:|^)\/\//, '')" title="YouTube"><i class="fa fa-youtube-square fa-2x"></i></a>
              <a v-if='user.custom_link' :href="'https://' + user.custom_link.replace(/(^\w+:|^)\/\//, '')" title="YourWebsite +"><i class="fa fa-globe fa-2x"></i></a>
						</p>
					</div><!-- .profile-right -->
				</div><!-- .col-md-4 -->
			</div><!-- .row -->
		</div><!-- .container mb-30 profile -->

		<!-- PROFILE DETAILS -->
		<div class="container profile-details crowd">
			<!-- Profile, Campaigns, Contributions, Comments tabs -->
			<div class="row">
				<div class="col-md-9">
					<!-- Nav tabs -->
					<ul class="nav nav-tabs" role="tablist" id="usertabs">
						<li role="presentation" class="active"><a href="#profile-about" class="first" aria-controls="profile-about" role="tab" data-toggle="tab">{{ $t("profile.show.about") }}</a></li>
						<li role="presentation"><a href="#profile-campaigns" aria-controls="profile-campaigns" role="tab" data-toggle="tab">{{ $t("profile.edit.campaigns") + ': ' + projects.length }}</a></li>
						<li role="presentation"><a href="#profile-contributions" aria-controls="profile-contributions" role="tab" data-toggle="tab">{{ $t("profile.edit.contributions") + ': ' + contributions.length }}</a></li>
						<li role="presentation"><a href="#profile-comments" aria-controls="profile-comments" role="tab" data-toggle="tab">{{ $t("profile.edit.comments") + ': ' + comments.length }}</a></li>
					</ul>
					<!-- Tab panes -->
					<div class="tab-content">
						<!-- Profile -->
						<div role="tabpanel" class="tab-pane fade in active" id="profile-about">
							<h3>{{ user.full_name }} <span v-if="user.profession" class="text-lowercase">- {{ user.profession.name }}.</span></h3>
							<p style="word-wrap: break-word;" v-html="user.description"></p>
						</div><!-- Profile -->
						<!-- Campaigns -->
						<div role="tabpanel" class="tab-pane fade" id="profile-campaigns">
              <div v-for="project in projects" :project="project" :key="project.id">
                <crowdfunding-tile v-if="project.crowdfunding" :project="project"></crowdfunding-tile>
                <fundraising-tile v-else :project="project" class="row"></fundraising-tile>
              </div>
						</div><!-- Campaigns -->
						<!-- Contributions -->
						<div role="tabpanel" class="tab-pane fade" id="profile-contributions">
							<p v-for="contribution in contributions" class="contributor">
                <router-link :to="{ name: 'show_crowdfunding', params: { id: contribution.project.id, title: contribution.project.title }}">
                  <strong>{{ contribution.project.title }}</strong>
                </router-link>
                <span class="when">{{ contribution.created_at | daysLeft }} {{ $t('daysAgo') }}</span>
                <span class="pull-right">
                  <strong>{{ contribution.project.currency | currencySymbol }}{{ contribution.amount }}</strong>
                </span>
              </p>
							<!-- <p class="contributor"><a href="fundraising-campaign.html"><strong>Title of Campaign</strong></a> <span class="when">yesterday</span> <span class="pull-right"><strong>$10</strong></span></p> -->
						</div><!-- Contributions -->
						<!-- Comments -->
						<div role="tabpanel" class="tab-pane fade" id="profile-comments">
              <div class="scroll-list">
                <p v-for="comment in comments" :key="comment" class="comment">
                  <router-link :to="{ name: 'show_crowdfunding', params: { id: comment.project.id, title: comment.project.title } }">
                    <div v-if="user.photo.thumb.url" class="avatar" style="height:60px">
                      <img :src="$server_url + user.photo.thumb.url" style="width:60px">
                    </div>
                    <strong>{{ comment.project.title }}</strong>
                  </router-link>
                  <span class="when">{{ comment.created_at | daysLeft }} {{ $t('daysAgo') }}</span>
                  </br>
                  {{ comment.body }}
                </p>
              </div>
						</div><!-- Comments -->
					</div><!-- .tab-content -->
				</div><!-- .col-md-9 -->
				<div class="col-md-3">
          <contact-user v-if="user.id" :user="user"></contact-user>
				</div><!-- .col-md-3 -->
			</div><!-- .row -->
		</div><!-- .container profile-details crowd -->

		<!-- STAR BOX -->
		<div class="container mt-50 mb-50">
			<p class="center"><img src="~assets/img/star.png"></p>
		</div><!-- .container .mt-50 .mb-50 -->
	</div>
</template>

<script>
// API
import userApi from '@/api/v1/user';
import commentsApi from '@/api/v1/comments';
import contributionsApi from '@/api/v1/contributions';
import projectsApi from '@/api/v1/projects';
// Components
import CrowdfundingTile from '@/components/Project/Tiles/Crowdfunding';
import FundraisingTile from '@/components/Project/Tiles/Fundraising';
import ContactUser from '@/components/Profile/Contact';
// Models
import projectModel from '@/models/project';
import userModel from '@/models/user';

export default {
  components: { CrowdfundingTile, FundraisingTile, ContactUser },
  data() {
    return {
      user: userModel.user,
      project: projectModel.project,
      comments: [],
      contributions: [],
      projects: [],
    };
  },
  methods: {
    setUser(user) {
      this.user = user;
    },
  },
  created() {
    userApi.getUser(this.$route.params.id, this.setUser);
    contributionsApi.userContributions(this.$route.params.id, (contributions) => {
      this.contributions = contributions;
    });
    commentsApi.userComments(this.$route.params.id, (comments) => { this.comments = comments; });
    projectsApi.getUserProjects(this.$route.params.id, (projects) => { this.projects = projects; });
  },
};
</script>



// WEBPACK FOOTER //
// Show.vue?f4200a0c